<template>
  <div v-if="displayNow" class="item-parent">
    <a
      v-if="searchVal === '' ? true : list.canDisplay"
      class="dropdown-item"
      href="javascript:void(0)"
      :class="depthClassName"
      @click.stop="onClickItem($event)"
    >
      <div class="dropdown-checkbox-circle-division">
        <input
          class="checkbox-custom"
          type="checkbox"
          :disabled="childList.length > 0 ? true : false"
          :checked="isItemSelected ? true : false"
        />
        <label
          for="checkbox-1"
          :class="
            allItemsSelected
              ? 'checkbox-custom-label'
              : someItemsSelected && isItemSelected
                ? 'checkbox-custom-label-disable'
                : 'checkbox-custom-label'
          "
        />
      </div>

      <div class="dropdown-item-text-division">
        <span class="dropdown-item-text-division-1">{{ list.name }}</span>

        <span
          v-if="childList.length > 0 || null"
          class="button-arrows dropdown-button-arrow"
        >
          <div v-if="showChildren || null" class="dropdown-button-arrow">
            <img
              v-if="isItemSelected || null"
              class="dropdown-button-arrow-img"
              src="@/assets/img/light-arrow-up-white.svg"
            />
            <img
              v-else
              class="dropdown-button-arrow-img"
              src="@/assets/img/light-arrow-up.svg"
            />
          </div>
          <div v-else class="dropdown-button-arrow">
            <img
              v-if="isItemSelected || null"
              class="dropdown-button-arrow-img"
              src="@/assets/img/light-arrow-down-white.svg"
            />
            <img
              v-else
              class="dropdown-button-arrow-img"
              src="@/assets/img/light-arrow-down.svg"
            />
          </div>
        </span>
      </div>
    </a>

    <div v-show="showChildren" v-if="childList.length > 0 || null">
      <div
        v-for="(item, itemIndex) in childList"
        :key="itemIndex"
        class="dropdown-item-row-inner"
      >
        <SelectMultiLevelItems
          v-if="item !== '' || null"
          :key="depth + 1"
          :list="item"
          :depth="depth + 1"
          :question-id="questionId"
          :selected-items="selectedItems"
          :search-val="searchVal"
          :item-offset-val="itemOffsetVal"
          @set-me-can-display="setMeCanDisplay"
          @select-parent-item="selectParentItem"
          @unselect-parent-item="unselectParentItem"
        />
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Watch, Vue } from "vue-facing-decorator";
import _ from "underscore";
import Utils from "@/utils/utilities";
import $ from "jquery";
import EventEmitter from "@/utils/eventEmitter";

@Component({})
export default class SelectMultiLevelItems extends Vue {
  @Prop()
  public list!: any;

  @Prop()
  public depth!: any;

  @Prop()
  public questionId!: any;

  @Prop()
  public selectedItems!: any;

  @Prop()
  public searchVal!: any;

  @Prop()
  public itemOffsetVal!: any;

  public showChildren = false;
  public childList: any = {};
  public depthClassName = "";
  public isItemSelected = false;
  public hasMatchedChild = true;
  public isChildItemSelected = false;
  public compUniqueId = "";
  public displayNow = false;
  public allItemsSelected = false;
  public someItemsSelected = false;
  public isParentMatched = false;

  @Watch("selectedItems")
  onUpdateItemSelected() {
    this.checkIsKeyValueExists();
  }

  @Watch("list")
  onUpdateList() {
    this.setChildList();
  }

  @Watch("searchVal")
  onChangeString() {
    this.checkMatchString();
  }

  @Watch("isItemSelected")
  onChangeIsItemSelected() {
    if (this.isItemSelected) {
      this.selectParentItem();
    } else {
      this.unselectParentItem();
    }
  }

  mounted() {
    this.setChildList();
    setTimeout(() => {
      if (this.isItemSelected) {
        this.showChildren = true;
      }
    }, 500);
  }

  onClickItem(e: any) {
    if (this.childList.length > 0) {
      const elmPostTop: any = e.currentTarget.offsetTop;
      const listContiner: any = $("#dropdown-scroll");

      this.toggleChildren();

      let scrollByPx =
        elmPostTop - listContiner.scrollTop() - this.itemOffsetVal;
      if (scrollByPx < listContiner.scrollTop()) {
        scrollByPx += listContiner.scrollTop();
      }

      if (this.showChildren && scrollByPx > 0) {
        listContiner && listContiner.animate({ scrollTop: scrollByPx }, 1000);
      }
    } else {
      EventEmitter.emit("APP_SELECT_MULTI_LEVEL_SETITEMS", {
        item: { ...this.list },
        level: this.depth,
      });
      this.checkIsKeyValueExists();
    }
  }
  toggleChildren() {
    this.showChildren = !this.showChildren;
  }

  async setChildList() {
    this.displayNow = false;
    const nextLevelListKey = await Utils.getListDataKeyAtLevel(
      this.questionId,
      this.depth,
    );
    if (
      nextLevelListKey &&
      this.list &&
      this.list[nextLevelListKey] &&
      this.list[nextLevelListKey] !== ""
    ) {
      this.childList = this.list[nextLevelListKey];
    } else {
      this.childList = {};
    }
    this.checkIsKeyValueExists();
    this.displayNow = true;
  }
  checkMatchString() {
    this.displayNow = false;
    if (this.searchVal) {
      if (
        this.list.name.toLowerCase().indexOf(this.searchVal.toLowerCase()) !==
        -1
      ) {
        this.list.canDisplay = true;
        this.showChildren = false;
        if ((this.$parent as any).list) {
          this.setMeCanDisplay();
          this.$emit("setMeCanDisplay");
        }
      } else {
        let parent = (this.$parent as any).list ? (this.$parent as any) : false;
        this.isParentMatched = false;
        while (parent) {
          if (
            parent.isParentMatched ||
            parent.list.name
              .toLowerCase()
              .indexOf(this.searchVal.toLowerCase()) !== -1
          ) {
            this.isParentMatched = true;
            break;
          } else if (
            parent.list.name
              .toLowerCase()
              .indexOf(this.searchVal.toLowerCase()) == -1
          ) {
            parent = (parent.$parent as any).list
              ? (parent.$parent as any)
              : false;
          }
        }
        if (this.isParentMatched) {
          this.list.canDisplay = true;
          this.showChildren = false;
        } else {
          this.list.canDisplay = false;
        }
      }
    } else {
      this.hideChildren();
      this.$emit("hideChildren");
    }
    this.displayNow = true;
  }
  setMeCanDisplay() {
    if ((this.$parent as any).list) {
      (this.$parent as any).displayNow = false;
      (this.$parent as any).list.canDisplay = true;
      (this.$parent as any).displayNow = true;
      (this.$parent as any).showChildren = true;
    }
  }
  hideChildren() {
    if ((this.$parent as any).list) {
      (this.$parent as any).showChildren = false;
    }
  }
  async checkIsKeyValueExists() {
    if (
      this.list &&
      this.list.id &&
      this.selectedItems &&
      this.selectedItems.length > 0
    ) {
      const itemRec = _.find(this.selectedItems, { id: this.list.id });
      if (itemRec) {
        this.isItemSelected = true;
      } else {
        this.isItemSelected = false;
      }
    } else {
      this.isItemSelected = false;
    }

    if (this.isItemSelected) {
      this.depthClassName = "selected-item depth-l-" + this.depth;
      this.$nextTick(function () {
        this.childCount();
      });
      this.$emit("selectParentItem");
    } else {
      this.depthClassName =
        this.childList.length > 0
          ? "PARENT-HERE depth-l-" + this.depth
          : "depth-l-" + this.depth;
    }
  }
  async getIDOfItem() {
    this.compUniqueId = await Math.random().toString(36).slice(2);
  }

  selectParentItem() {
    if (!this.isItemSelected) {
      this.isItemSelected = true;
      this.depthClassName += " PARENT-SELECTED selected-item-parent";
      this.isChildItemSelected = true;
    }
    this.$nextTick(function () {
      this.childCount();
    });
    this.$emit("selectParentItem");
  }

  unselectParentItem() {
    if (this.childList.length > 0) {
      const isChildItemSelected = this.selectedItems.some((selectedItem) => {
        return this.list?.childIds?.includes(selectedItem.id);
      });

      if (!isChildItemSelected) {
        this.isItemSelected = false;
        this.depthClassName = this.depthClassName.replace(
          "PARENT-SELECTED selected-item-parent",
          "",
        );
      }
    }
    this.$emit("unselectParentItem");
  }

  childCount() {
    this.allItemsSelected = true;
    this.someItemsSelected = false;
    let temp = 0;
    for (let i in (this as any).$children) {
      temp = 1;
      this.allItemsSelected =
        this.allItemsSelected &&
        ((this as any).$children[i] as any).isItemSelected &&
        ((this as any).$children[i] as any).allItemsSelected &&
        this.isItemSelected;
      this.someItemsSelected =
        this.someItemsSelected ||
        ((this as any).$children[i] as any).isItemSelected;
    }
    if (temp == 0) {
      this.allItemsSelected = this.isItemSelected;
      this.someItemsSelected = this.isItemSelected;
    }
  }
}
</script>
<style lang="scss" scoped>
.depth-l-1 {
  padding-left: 20px !important;
}
.depth-l-2 {
  padding-left: 50px !important;
}
.depth-l-3 {
  padding-left: 80px !important;
}
.depth-l-4 {
  padding-left: 110px !important;
}
.depth-l-5 {
  padding-left: 140px !important;
}
.selected-item-parent {
  background: #0345bd;
  border-radius: 0px;
  color: white !important;
  margin-bottom: 2px;
}
.selected-item {
  background: #387dff;
  border-radius: 0px;
  box-shadow: 0px 0px 10px rgba(183, 183, 183, 0.4);
  color: white !important;
  border: none;
}
.dropdown-item-text-division {
  display: flex;
  width: 100%;
  white-space: normal;
  word-break: break-word;
  margin-left: 0%;
  padding-right: 10px;

  .button-arrows {
    img {
      height: 8px;
      width: 20px;
    }
  }
}

.dropdown-checkbox-circle-division {
  display: inline-block;
}
.checkbox-custom {
  opacity: 0;
  position: absolute;
  width: 24px;
  height: 24px;
}

.checkbox-custom,
.checkbox-custom-label,
.checkbox-custom-label-disable {
  display: inline-block;
  vertical-align: middle;
  margin: 5px;
  cursor: pointer;
  text-align: justify;
  word-break: break-word;
  line-height: 1em !important;
  white-space: normal;
}

.checkbox-custom-label,
.checkbox-custom-label-disable {
  position: relative;
  top: 0%;
  font-style: normal;
  font-weight: normal;
  line-height: 24px;
}

.checkbox-custom + .checkbox-custom-label:before,
.checkbox-custom + .checkbox-custom-label-disable:before {
  content: "";
  background: #fff;
  border: 2px solid #0345bd;
  display: inline-block;
  vertical-align: middle;
  width: 20px;
  height: 20px;
  padding: 0px;
  margin-right: 10px;
  text-align: center;
  border-radius: 50%;
}
.checkbox-custom + .checkbox-custom-label-disable:before {
  background: #c1c1c1;
}

.checkbox-custom:focus + .checkbox-custom-label,
.radio-custom:focus + .radio-custom-label {
  outline: 1px solid #ddd; /* focus style */
}
.dropdown-item {
  color: #0345bd;
  font-size: 18px;
  padding: 10px 10px 10px 20px;
  border-bottom: 1px solid rgba(183, 183, 183, 0.25);
  width: 100%;
  display: flex;
  align-items: center;
}
.dropdown-item.active,
.dropdown-item:active {
  background: unset;
}
.dropdown-item-text-division-1 {
  width: 100%;
}
</style>
